export default "__VITE_ASSET__Uyu$ngzb__"